(function() {
    angular
        .module("app")
        .controller("CloneToDevicesModalController", CloneToDevicesModalController)

    CloneToDevicesModalController.$inject = [
        "$stateParams",
        "$scope",
        "$uibModalInstance",
        "devicesService",
        "messagesService",
        "userMessagingService",
        "messageIDs"
    ]

    function CloneToDevicesModalController(
        $stateParams,
        $scope,
        $uibModalInstance,
        devicesService,
        messagesService,
        userMessagingService,
        messageIDs
    ){
        "use strict"

        /**
            $scope variables
         **/
        $scope.messageBoardID = $stateParams.message_board_id

        // Get Message Boards
        $scope.messageBoards = []
        $scope.getDevices = function() {
            devicesService.getDevices(function(categorized) {
                $scope.messageBoards = categorized.messageBoards.sort((a, b) => { return a.name > b.name })
            })
        }
        $scope.getDevices()

        $scope.cloneMessageToDevices = function(messageBoardIDs) {
            messagesService.cloneMessageToDevices(
                $stateParams.message_board_id,
                messageIDs,
                messageBoardIDs,
                function() {
                    //Success
                    userMessagingService.success("Message Clone Request Sent: This process may take a few minutes.")
                },
                function(error) {
                    //Failure
                    userMessagingService.error(error)
                }
            )
        }

        $scope.ok = function() {
            $uibModalInstance.close()
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
